/*eslint-disable */
const emailRegexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
/*eslint-enable */

export default {
  isRequired: value => (value ? undefined : "Required"),
  isEmail: value =>
    value && !emailRegexp.test(value) ? "Invalid email address" : undefined,

  isString: value =>
    typeof value === "string" ? "Must be a string" : undefined,
  maxLength: max => value =>
    value && value.length > max
      ? `Must be ${max} characters or less`
      : undefined,
  minLength: min => value =>
    value && value.length < min
      ? `Must be ${min} characters or more`
      : undefined
}



// WEBPACK FOOTER //
// ./src/lib/validators.js